import styled from '@emotion/styled'
import { sendBannerClick } from 'utils/hooks/analytics'
import { genPathByNavData } from 'utils/api'
import { useRouter } from 'next/router'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { useBannerGAForNonCarousel } from 'utils/hooks/useBannerGA'

const minHeight = '186px'

const BannerImg = styled.img`
  ${({ theme }) => `
    min-height: ${minHeight};
    width: 100%;
    border-radius: ${theme.spacing(6)};
    cursor: pointer;
  `}
`

const Img = styled.img`
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
  cursor: pointer;
`

const AdvertisementBanner = ({ banner, bannerLocation }) => {
  const router = useRouter()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'))

  const onBannerClick = async () => {
    sendBannerClick({
      banner,
      bannerLocation,
    })

    const { path, isExternalLink } = await genPathByNavData(banner.navData)
    if (path) {
      if (isExternalLink) {
        window.open(path, '_blank')
      } else {
        router.push(path)
      }
    }
  }

  useBannerGAForNonCarousel({
    bannerData: [banner],
    bannerLocation,
    isRepeated: false,
  })

  useBannerGAForNonCarousel({
    bannerData: [banner],
    bannerLocation,
    isRepeated: true,
  })

  if (isMobile) {
    return (
      <Box
        my={{ xs: 18, lg: 24 }}
        mx={{ xs: 0, md: '5%' }}
        data-banner-id={banner?._id}
      >
        <Img
          src={banner?.imageDouble?.url}
          onClick={onBannerClick}
          id={`advertisement-banner-${banner._id}`}
        />
      </Box>
    )
  }

  return (
    <Box my={24} data-banner-id={banner?._id}>
      <Img
        src={banner?.image?.url}
        onClick={onBannerClick}
        id={`advertisement-banner-${banner._id}`}
      />
    </Box>
  )
}

export { minHeight, BannerImg, AdvertisementBanner }
